var _excluded = ["confirmText", "cancelText"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { DatePicker as AntdDatePicker } from 'antd';
import { DatePicker as AdmDatePicker } from 'antd-mobile';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import updateLocale from 'dayjs/plugin/updateLocale';
import useStyles from "./style";
dayjs.extend(updateLocale);
dayjs.updateLocale('zh-cn', {
  weekStart: 0
});
function DatePickerForPC(props) {
  return /*#__PURE__*/React.createElement(AntdDatePicker, props);
}
function DatePickerForMobile(_ref) {
  var _ref$confirmText = _ref.confirmText,
    confirmText = _ref$confirmText === void 0 ? 'Done' : _ref$confirmText,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles(),
    st = _useStyles.styles;
  return /*#__PURE__*/React.createElement(AdmDatePicker, _extends({}, rest, {
    confirmText: confirmText,
    cancelText: cancelText,
    className: st.datePickerForMobileWrap
  }));
}

// DatePicker.RangePicker = RangePicker

export { DatePickerForPC, DatePickerForMobile };